"use client";

import { EhrInstructionsCard } from "@/src/components/ehr-instructions-card";
import { Alert, AlertDescription } from "@/src/components/shadcn/ui/alert";
import { Button } from "@/src/components/shadcn/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/src/components/shadcn/ui/tooltip";
import { ValerieCard } from "@/src/components/valerie-card";

import type { ReactNode } from "react";

interface ReferralAuthInstructionsCardProps {
  appearance?: "ehr" | "standard";
  instruction: ReactNode;
  openButtonTooltip: string;
  isOpenButtonDisabled: boolean;
  isOpening: boolean;
  onOpenAuthorization: () => void;
}

export function ReferralAuthInstructionsCard({
  appearance = "ehr",
  instruction,
  openButtonTooltip,
  isOpenButtonDisabled,
  isOpening,
  onOpenAuthorization,
}: ReferralAuthInstructionsCardProps) {
  const content = (
    <div className="flex flex-col gap-4 text-sm text-muted-foreground">
      <Alert>
        <AlertDescription>{instruction}</AlertDescription>
      </Alert>

      <TooltipProvider delayDuration={100}>
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="inline-flex w-full">
              <Button
                variant="outline"
                className="w-full border-primary text-primary hover:bg-primary/10"
                onClick={onOpenAuthorization}
                disabled={isOpenButtonDisabled}
              >
                {isOpening ? "Opening..." : "Open Authorization"}
              </Button>
            </span>
          </TooltipTrigger>
          <TooltipContent side="top" className="max-w-xs text-center">
            {openButtonTooltip}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );

  if (appearance === "standard") {
    return <ValerieCard title="Referral Authorization Instructions">{content}</ValerieCard>;
  }

  return (
    <EhrInstructionsCard>
      <div className="flex flex-col gap-4">
        <p className="text-center text-sm font-medium text-foreground">Referral Authorization Instructions</p>
        {content}
      </div>
    </EhrInstructionsCard>
  );
}
